import * as React from 'react';
import { Text } from '../../../new-libby/core/typography';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { Column } from '../../layout/layout';
export var SettingsContainerSection = function (props) {
    var _a;
    var classNames = namespacedClassnames('settings-container-section', props.className || '', (_a = {}, _a['with-avatar'] = props.avatar, _a));
    var sectionText = (React.createElement(Column, { className: 'section-text', verticalAlignment: props.verticalTextAlignment || 'center' },
        React.createElement(Text, { type: 'hs', color: 't20', className: 'title' }, props.title),
        props.description ? React.createElement(Text, { type: 't', color: 't30', className: 'description' }, props.description) : null));
    var sectionTextWithAvatar = (React.createElement("div", { className: 'left-container' },
        React.createElement("div", { className: 'avatar-container' }, props.avatar),
        sectionText));
    var sectionElement = props.avatar ? sectionTextWithAvatar : sectionText;
    return (React.createElement("div", { className: classNames },
        sectionElement,
        React.createElement("div", { className: 'actions-container' }, props.children)));
};
//# sourceMappingURL=settings-container-section.js.map